export const computerData = [{
        "id": "1",
        "product": "Computer",
        "image": "/assets/Computers/12.jpg",
        "company": "Dell",
        "model": "Inspiron 15",
        "price": "899.99",
        "category": "Electronics",
        "description": "A versatile laptop with powerful performance and a sleek design."
    },
    {
        "id": "2",
        "product": "Computer",
        "image": "/assets/Computers/4.jpg",
        "company": "HP",
        "model": "Pavilion 27",
        "price": "1299.00",
        "category": "Electronics",
        "description": "An all-in-one desktop PC with a large display and high-speed processing."
    },
    {
        "id": "3",
        "product": "Computer",
        "image": "/assets/Computers/3.jpg",
        "company": "Apple",
        "model": "MacBook Air",
        "price": "1199.00",
        "category": "Electronics",
        "description": "An ultrathin and lightweight laptop known for its portability and smooth performance."
    },
    {
        "id": "4",
        "product": "Computer",
        "image": "/assets/Computers/11.jpg",
        "company": "Lenovo",
        "model": "IdeaPad Flex",
        "price": "799.50",
        "category": "Electronics",
        "description": "A flexible 2-in-1 laptop with touchscreen capabilities and powerful processing."
    },
    {
        "id": "5",
        "product": "Computer",
        "image": "/assets/Computers/5.jpg",
        "company": "Acer",
        "model": "Predator Helios 300",
        "price": "1299.00",
        "category": "Electronics",
        "description": "A gaming laptop with high-performance graphics and advanced cooling technology."
    },
    {
        "id": "6",
        "product": "Computer",
        "image": "/assets/Computers/6.jpg",
        "company": "Microsoft",
        "model": "Surface Pro 7",
        "price": "999.99",
        "category": "Electronics",
        "description": "A versatile 2-in-1 tablet and laptop with a detachable keyboard and stylus support."
    },
    {
        "id": "7",
        "product": "Computer",
        "image": "/assets/Computers/7.jpg",
        "company": "Asus",
        "model": "ZenBook 14",
        "price": "899.00",
        "category": "Electronics",
        "description": "A compact laptop with a premium build, strong performance, and long battery life."
    },
    {
        "id": "8",
        "product": "Computer",
        "image": "/assets/Computers/8.jpg",
        "company": "Alienware",
        "model": "Aurora R10",
        "price": "1999.00",
        "category": "Electronics",
        "description": "A high-end gaming desktop with customizable components and advanced graphics capabilities."
    },
    {
        "id": "9",
        "product": "Computer",
        "image": "/assets/Computers/9.jpg",
        "company": "HP",
        "model": "EliteBook 840",
        "price": "1299.00",
        "category": "Electronics",
        "description": "A business laptop with robust security features, reliable performance, and sleek design."
    },
    {
        "id": "10",
        "product": "Computer",
        "image": "/assets/Computers/10.jpg",
        "company": "Lenovo",
        "model": "ThinkCentre M720",
        "price": "799.00",
        "category": "Electronics",
        "description": "A compact and powerful desktop computer suitable for business and productivity tasks."
    },
    {
        "id": "11",
        "product": "Computer",
        "image": "/assets/Computers/2.jpg",
        "company": "Dell",
        "model": "XPS 13",
        "price": "1499.00",
        "category": "Electronics",
        "description": "A premium ultrabook with a stunning display, strong performance, and sleek design."
    },
    {
        "id": "12",
        "product": "Computer",
        "image": "/assets/Computers/1.jpg",
        "company": "Acer",
        "model": "Chromebook 14",
        "price": "349.99",
        "category": "Electronics",
        "description": "A lightweight and affordable laptop running on Chrome OS, ideal for web-based tasks."
    }
]